import { render, staticRenderFns } from "./ChangeDestinationDialog.vue?vue&type=template&id=f5472b4c&scoped=true"
import script from "./ChangeDestinationDialog.vue?vue&type=script&lang=js"
export * from "./ChangeDestinationDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeDestinationDialog.vue?vue&type=style&index=0&id=f5472b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5472b4c",
  null
  
)

export default component.exports